// extracted by mini-css-extract-plugin
module.exports = {"p1ppj68":"p1ppj68","r166uj18":"r166uj18"};